
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeSystemModule  from "@/store/modules/barcodeSystem";
import WarehouseLocationModule  from "@/store/modules/barcodeSystem/warehouseLocation";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { WarehouseLocationResource } from "../../models/api/barcodeSystem/warehouseLocations/get";
import { EditWarehouseLocationModel } from "@/models/ui/editWarehouseLocation";
import { formatBool, formatDateWithTime } from "@/utils";
import InventoryActions from "@/components/barcodeSystem/inventory/InventoryActions.vue";

const barcodeSystemModuleState = getModule(BarcodeSystemModule);
const warehouseLocationsModuleState = getModule(WarehouseLocationModule);
const inventoryModuleState = getModule(InventoryModule);

import notifications from "../../lib/notifications";
import { InventoryItemResource } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import { PalletResource } from "@/models/api/barcodeSystem/inventory/pallets";
import { BulkInventoryItemResource } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";
@Component({
  components: {
    Select,
    InventoryActions
  }
})
export default class WarehouseLocations extends Vue {
  loading: boolean = false;
  editWarehouseLocationModel: EditWarehouseLocationModel = null;
  warehouseLocationId: number | null = null;
  warehouseLocation: WarehouseLocationResource | null = null;
  inventoryItemTabIsLoading: boolean = false;
  palletTabIsLoading: boolean = false;
  bulkInventoryItemTabIsLoading: boolean = false;
  inventoryItems: InventoryItemResource[] | null = null;
  pallets: PalletResource[] | null = null;
  bulkInventoryItems: BulkInventoryItemResource[] | null = null;  
  showUnlockLocationPrompt: boolean = false;
  
  get itemFields() {
    return inventoryModuleState.itemFields;
  }

  get palletFields() {
    return inventoryModuleState.palletFields;
  }

  get bulkFields() {
    return inventoryModuleState.bulkFields;
  }

  get formattedLastCycleCountedDate() {
    return formatDateWithTime(this.editWarehouseLocationModel.lastCycleCountDate);
  }

  set formattedLastCycleCountedDate(val: string){

  }

  get isLocked(): boolean {
    return this.editWarehouseLocationModel && this.editWarehouseLocationModel.locked != null;
  }


  created() {
  }

  async loadWarehouseLocation(warehouseLocationId: number) {
    this.loading = true;
    let response = await warehouseLocationsModuleState.getWarehouseLocation(warehouseLocationId);
    this.warehouseLocation  = response.data;
    this.loading = false;
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  formatDateWithTime(val: string)
  {
    return formatDateWithTime(val);
  }

  descriptionState() {
    return this.editWarehouseLocationModel.description ? null : false;
  }

  codeState() {
    return this.editWarehouseLocationModel.code ? null : false;
  }

  validateForm() {
    if(this.descriptionState() === false) return false;
    if(this.codeState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveWarehouseLocation() {
    if(!this.validateForm()) return;
    var response = null;
    this.editWarehouseLocationModel.saving = true;
    if (this.editWarehouseLocationModel.isNew()) {
      try {
        response = await warehouseLocationsModuleState.createWarehouseLocation(this.editWarehouseLocationModel.toCreateWarehouseLocationRequest());
        this.editWarehouseLocation(response.data.resource.id);
        notifications.success("Warehouse Location Saved", "Successfully created warehouse location");
      } catch (ex) {
        notifications.error("Save Warehouse Location", `Failed to create warehouse location. ${ex.response.data}`, ex);
      } finally {
        this.editWarehouseLocationModel.saving = false;
      }
    } else {
      try {
        response = await warehouseLocationsModuleState.updateWarehouseLocation(this.editWarehouseLocationModel.toUpdateWarehouseLocationRequest());
        notifications.success("Warehouse Location Saved", "Successfully saved warehouse location");
      } catch (ex) {
        notifications.error("Save Warehouse Location", `Failed to save warehouse location${ex}`, ex);
      } finally {
        this.editWarehouseLocationModel.saving = false;
      }
    }
  }  
  
  hideEdit() {
    this.editWarehouseLocationModel.visible = false;
    this.editWarehouseLocationModel = null;
  }

  async editWarehouseLocation(warehouseLocationId: number | null = null) {
    this.warehouseLocation = null;
    if(warehouseLocationId != null)
      await this.loadWarehouseLocation(warehouseLocationId);
    this.editWarehouseLocationModel = new EditWarehouseLocationModel();
    this.editWarehouseLocationModel.visible = true;

    if (this.warehouseLocation) {
      this.editWarehouseLocationModel.showForExistingWarehouseLocation(this.warehouseLocation);

      this.inventoryItemTabIsLoading = true;
      this.palletTabIsLoading = true;
      this.bulkInventoryItemTabIsLoading = true;
      this.inventoryItems = null;
      this.pallets = null;
      this.bulkInventoryItems = null;

      try
      {
        let response = await warehouseLocationsModuleState.getWarehouseLocationInventoryItems({id: this.warehouseLocationId, facilityCode: barcodeSystemModuleState.currentFacilityCode});       
        this.inventoryItems = response.data;  
      }      
      catch (ex) {
        notifications.error("Failed to load inventory", "Failed to load inventory items.", ex);
      } finally {
        this.inventoryItemTabIsLoading = false;
      }

      try
      {
        let response = await warehouseLocationsModuleState.getWarehouseLocationPallets({id: this.warehouseLocationId, facilityCode: barcodeSystemModuleState.currentFacilityCode});
        this.pallets = response.data;
      }      
      catch (ex) {
        notifications.error("Failed to load pallets", "Failed to load pallets.", ex);
      } finally {
        this.palletTabIsLoading = false;
      }

      try
      {
        let response = await warehouseLocationsModuleState.getWarehouseLocationBulkInventoryItems({id: this.warehouseLocationId, facilityCode: barcodeSystemModuleState.currentFacilityCode});
        this.bulkInventoryItems = response.data;
      }
      catch (ex) {
        notifications.error("Failed to load bulk inventory", "Failed to load bulk inventory items.", ex);
      } finally {
        this.bulkInventoryItemTabIsLoading = false;
      }   
    } else {
      this.editWarehouseLocationModel.showForNewWarehouseLocation(this.currentFacilityCode);
    }
  }

  async unlockLocation()
  {      
    try {
      let response = await warehouseLocationsModuleState.forceUnlockWarehouseLocation({id: this.warehouseLocationId});
      notifications.success("Warehouse Location Unlocked", "Successfully unlocked warehouse location");
      this.editWarehouseLocation(this.warehouseLocationId)
      this.closeUnlockLocationPrompt();
    } catch (ex) {
      notifications.error("Failed to unlock warehouse location", "Failed to load bulk inventory items.", ex);
    }  
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }

  onInventoryItemDoubleClicked(item){
    inventoryModuleState.viewInventoryItemShortcutAction({selectedItems: [item]});
  }

  onPalletDoubleClicked(item){
    inventoryModuleState.viewPalletShortcutAction({selectedItems: [item]});
  }

  onBulkInventoryItemDoubleClicked(item){
    inventoryModuleState.viewBulkInventoryItemShortcutAction({selectedItems: [item]});
  }

  promptForLocationUnlock() {
    this.showUnlockLocationPrompt = true;
  }

  closeUnlockLocationPrompt() {
    this.showUnlockLocationPrompt = false;
  }
  
}
